module.exports = __webpack_public_path__ + "img/413-a0659d.png";